import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Teddy Chen，泰迪軟體創辦人，部落格「搞笑談軟工」版主。Teddy 目前為敏捷顧問與敏捷課程講師，並在台北科技大學資工系研究所擔任兼任助理教授，開設敏捷與精實軟體開發、軟體架構課程。`}</p>
    <p>{`部落格: `}<a parentName="p" {...{
        "href": "http://teddy-chen-tw.blogspot.com/"
      }}>{`http://teddy-chen-tw.blogspot.com/`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      